import React from 'react';
import { AttachmentPreviewModal } from '@/components/AttachmentPreviewModal';
import { useAttachmentBlobUrl } from '@/hooks/useAttachmentBlobUrl';
import type { Attachment } from '@/types/attachment';
import { triggerDownload } from '@/utils/file';

interface Props {
  attachment: Attachment;
  onClose: () => void;
  onDownloaded: () => void;
}

export const AttachmentPreview: React.FC<Props> = ({
  attachment,
  onClose,
  onDownloaded,
}) => {
  const blobUrl = useAttachmentBlobUrl(attachment.id, attachment.name);

  const handleDownload = () => {
    if (!blobUrl) {
      return;
    }

    triggerDownload(blobUrl, attachment.name);
    onDownloaded();
    onClose();
  };

  return (
    <AttachmentPreviewModal
      name={attachment.name}
      url={blobUrl}
      onClose={onClose}
      onDownload={handleDownload}
    />
  );
};
